exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".error-container{max-width:960px}.well--1x{padding:5px}.well--2x{padding:10px}.well--3x{padding:15px}.vr--1x{margin-bottom:5px}.vr--2x{margin-bottom:10px}.vr--3x{margin-bottom:15px}.typ--hdg1{font-weight:700;font-size:2em}.typ--breathable{line-height:1.3}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/components/error/error.scss
// module id = 499
// module chunks = 0